module.exports = __webpack_public_path__ + "img/micromall_online04.8b732236.png";